import type { FAQItem } from "@/landing/lib/types";

export const CLI_FAQ_ITEMS: FAQItem[] = [
  {
    question: "How does it work?",
    answer:
      'Simply install the CLI (or integrate with our API) and run your first command. For example: wonda generate video "a sneaker ad on a neon background" --wait -o ad.mp4. That\'s it: one command to generate, one to edit, one to publish. You can chain them together or let your AI agent handle the whole pipeline.',
  },
  {
    question: "Is it free?",
    answer:
      "There's no free plan. Wonda Pro is $49.99/month for the full CLI and API: every model, editing operations, and posting. No generation credits are included: you pay for what you generate on top, at the same price as fal.ai or cheaper, with no markup.",
  },
  {
    question: "Will the content actually look good?",
    answer:
      "We\u2019re optimizing for high quality social media content because that\u2019s what goes viral & converts. Access the best videos + embedded enhancements (audio & visual) + tiktok native editing (captions, text overlays, talking heads, split screens). The result is production-ready content, not raw AI output with a filter.",
  },
  {
    question: "How is this different from fal.ai or Replicate?",
    answer:
      "Those are model APIs; you get raw inference and have to build everything else yourself. Wonda gives you the full pipeline in one CLI: generate with 25+ models, edit (captions, overlays, music, transitions), publish to Instagram and TikTok via native APIs, write to X, Reddit, and LinkedIn through WAB, and track performance. For the same price, one tool with native enhancements instead of five APIs and ffmpeg.",
  },
  {
    question: "Why would I use this over Remotion?",
    answer:
      "Remotion is a video rendering framework. You code every frame in React. Wonda gives you AI generation, tiktok native editing operations, and social publishing out of the box. Remotion is great but a bit limited if you want to push the cursor towards reality. Also: all our editing operations are free.",
  },
  {
    question: "Can I automate my Instagram and TikTok?",
    answer:
      "Yes. Generate, edit, and publish in a single pipeline inside Claude Code, Codex or Cursor. Instagram and TikTok use native platform APIs. X, Reddit, and LinkedIn write through your connected account in WAB.",
  },
  {
    question: "Can my AI coding agent use this?",
    answer:
      "That\u2019s what it\u2019s built for. Wonda is agent-native: JSON output by default, structured errors with hints, --wait for blocking, --quiet for piping, and self-teaching via wonda skill install. Claude Code, Codex, and Cursor can generate, edit, and publish content without human intervention.",
  },
  {
    question: "What kind of content can I actually make?",
    answer:
      "Ads, UGC-style videos, talking heads, product demos, b-roll with animated captions, image carousels, TikTok slideshows, telenovelas: from raw content to a fully edited video with captions, voiceover, and transitions. 25+ video and image models, plus text-to-speech and music generation.",
  },
  {
    question: "Can I integrate this into my SaaS?",
    answer:
      "Yes. The same capabilities available in the CLI are exposed through our REST API with full JSON responses. Use it to power content generation inside your own product: white-label video creation, automated ad pipelines, or any workflow where you need media generation at scale. For higher concurrency & priority queuing, please contact us at contact@wonda.sh.",
  },
  {
    question: "Who is Wonda for?",
    answer:
      "AI agents. Anyone who wants to automate their social media content \u2013 growth engineers, SaaS founders, performance marketers, vibecoders, dropshippers, agencies\u2026 Now you can test content at scale and test 50 ad variations instead of 3. If you build with Claude Code, Cursor or Codex, this is your media stack.",
  },
];
